import connect from "../scripts/database.js";

export var Quotes = {
  getQuotes(uid) {
    return new Promise((resolve, reject) => {
      connect.db
        .collection("quotes")
        .where("forUser", "==", uid)
        .get()
        .then(results => {
          resolve(results);
        })
        .catch(err => {
          console.warn(err);
        });
    });
  },
  saveQuote(quote) {
    connect.db
      .collection("quotes")
      .doc(quote.id)
      .update({
        acceptedDate: quote.acceptedDate || null,
        assignedTo: quote.assignedTo || null,
        deliveryTimeframe: quote.deliveryTimeframe || null,
        forUser: quote.forUser,
        hasDock: quote.hasDock || false,
        items: quote.items,
        lastUpdated: Date.now(),
        lastUpdatedBy: quote.lastUpdatedBy || null,
        lastViewed: quote.lastViewed || null,
        liftGateCharge: quote.liftGateCharge || 0,
        notes: quote.notes || null,
        optionsConsent: quote.optionsConsent || null,
        requestedTime: quote.requestedTime || null,
        specConsent: quote.specConsent || null,
        state: quote.state,
        startedAt: quote.startedAt || null,
        step: quote.step || 1,
        version: quote.version || null
      })
      .then(function() {
        console.log(quote.id + " saved");
      })
      .catch(error => {
        console.warn(error);
      });
  },
  createQuote(quote) {
    connect.db
      .collection("quotes")
      .doc(quote.id)
      .set({
        assignedTo: quote.assignedTo || null,
        deliveryTimeframe: quote.deliveryTimeframe || null,
        forUser: quote.forUser,
        hasDock: quote.hasDock || false,
        id: quote.id,
        items: quote.items,
        lastUpdated: Date.now(),
        lastUpdatedBy: quote.lastUpdatedBy || null,
        lastViewed: quote.lastViewed || null,
        notes: quote.notes || null,
        optionsConsent: quote.optionsConsent || null,
        specConsent: quote.specConsent || null,
        state: quote.state
      })
      .then(function() {
        console.log(quote.id + " saved");
      })
      .catch(error => {
        console.warn(error);
      });
  },
  newQuote(quoteID, userID, userData) {
    return new Promise((resolve, reject) => {
      connect.db
        .collection("quotes")
        .doc(quoteID)
        .set({
          assignedTo: userData.assignedRep || null,
          deliveryTimeframe: null,
          forUser: userID,
          hasDock: false,
          id: quoteID,
          items: [],
          lastUpdated: Date.now(),
          lastUpdatedBy: userID || null,
          lastViewed: Date.now(),
          notes: "",
          optionsConsent: false,
          specConsent: false,
          state: "draft"
        })
        .then(function() {
          console.log(quoteID + " saved");
          resolve({
            assignedTo: userData.assignedRep || null,
            deliveryTimeframe: null,
            forUser: userID || null,
            hasDock: false,
            id: quoteID,
            items: [],
            lastUpdated: Date.now(),
            lastUpdatedBy: userID || null,
            lastViewed: Date.now(),
            notes: "",
            optionsConsent: false,
            specConsent: false,
            state: "draft"
          });
        })
        .catch(error => {
          console.warn(error);
          reject("");
        });
    });
  },
  deleteQuote(quoteID) {
    return new Promise((resolve, reject) => {
      connect.db
        .collection("quotes")
        .doc(quoteID)
        .delete()
        .then(function() {
          console.log(quoteID + " deleted");
          resolve(quoteID);
        })
        .catch(error => {
          console.warn(error);
          reject("");
        });
    });
  }
};
